import React, { useEffect, useState } from "react";
import { UserContext } from "../contexts/UserContext";
import UserAPI from "../apis/UserAPI";
import styled from "styled-components";

const UserProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(undefined);
  const [profile, setProfile] = useState(undefined);

  useEffect(() => {
    const unsubscribe = UserAPI.onAuthStateChanged((user) => {
      setUserId(user?.uid);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!userId) return;
    setProfile(undefined);
    const unsubscribe = UserAPI.subscribeToProfileDetails(
      userId,
      (key, value) => setProfile((state) => ({ ...state, [key]: value })),
      (key) => setProfile((state) => ({ ...state, [key]: undefined }))
    );
    return () => unsubscribe();
  }, [userId]);

  // console.log(`userId: ${userId}`);

  return (
    <UserContext.Provider
      value={{
        id: userId,
        ...profile,
      }}
    >
      {!loading ? (
        children
      ) : (
        <Container>
          <Spinner src="loading.gif" />
        </Container>
      )}
    </UserContext.Provider>
  );
};

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
`;

const Spinner = styled.img`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;

  margin: auto;
  width: 25px;
  height: 25px;
`;

export default UserProvider;
